import { DaDataAPI as daData } from './dadata';
import { agreement } from "./documents/agreement";

export * from './addParamsToUrl';

export const API = {
  daData,
  agreement
};
